'use client';

import React, { useMemo, useState } from 'react';

import { Button, Typography } from 'lighthouse';

import SwipeableDrawer from '@/widgets/SwipeableDrawer';

import { SellerRow } from './components';
import { OtherSellersProps } from './models';
import { sortOffers } from './utils';

import { Shop } from 'iconsax-react';

const DESKTOP_INITIAL_COUNT = 3;
const MOBILE_INITIAL_COUNT = 2;

export const OtherSellers = ({ allStores, winner, selectedSeller, onSelectSeller, addToCartProps }: OtherSellersProps) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const sortedStores = useMemo(() => sortOffers(allStores), [allStores]);

    if (sortedStores.length === 0) return null;

    const desktopStores = isExpanded ? sortedStores : sortedStores.slice(0, DESKTOP_INITIAL_COUNT);
    const mobileStores = sortedStores.slice(0, MOBILE_INITIAL_COUNT);

    return (
        <section id='sellers' className='scroll-mt-20'>
            <div className='mb-3 flex items-center justify-between'>
                <Typography variant='h6' color='blackHighEmphasis' component='h2' className='flex items-center gap-2 !text-base md:!text-lg'>
                    <Shop color='currentcolor' size={20} className='text-primary' />
                    مقایسه و انتخاب فروشندگان
                </Typography>
                <Typography variant='caption' color='blackMediumEmphasis'>
                    {allStores.length} فروشنده
                </Typography>
            </div>

            <div className='hidden flex-col gap-3 rounded-lg p-2 md:flex'>
                <div role='list' className='flex flex-col gap-3'>
                    {desktopStores.map((store) => (
                        <SellerRow
                            key={store.offerId ?? store.productUuid}
                            vendor={store}
                            isWinner={store.offerId === winner.offerId}
                            isSelected={selectedSeller?.offerId === store.offerId}
                            onSelect={onSelectSeller}
                            addToCartProps={addToCartProps}
                        />
                    ))}
                </div>
                {sortedStores.length > DESKTOP_INITIAL_COUNT && !isExpanded && (
                    <Button variant='outlined' onClick={() => setIsExpanded(true)} className='!border-dashed'>
                        مشاهده {sortedStores.length - DESKTOP_INITIAL_COUNT} فروشنده دیگر
                    </Button>
                )}
            </div>

            <div className='mt-4 flex flex-col gap-3 md:hidden'>
                <div role='list' className='flex flex-col gap-4'>
                    {mobileStores.map((store) => (
                        <SellerRow
                            key={store.offerId ?? store.productUuid}
                            vendor={store}
                            isWinner={store.offerId === winner.offerId}
                            isSelected={selectedSeller?.offerId === store.offerId}
                            onSelect={onSelectSeller}
                            addToCartProps={addToCartProps}
                        />
                    ))}
                </div>
                {sortedStores.length > MOBILE_INITIAL_COUNT && (
                    <Button variant='outlined' onClick={() => setIsDrawerOpen(true)} className='!border-dashed'>
                        مقایسه {sortedStores.length} فروشنده
                    </Button>
                )}
            </div>

            <SwipeableDrawer
                title={<Typography fontWeight={700}>مقایسه و انتخاب فروشنده</Typography>}
                open={isDrawerOpen}
                onClose={() => setIsDrawerOpen(false)}>
                <div role='list' className='flex flex-col gap-3 bg-gray-50 p-2'>
                    {sortedStores.map((store) => (
                        <SellerRow
                            key={store.offerId ?? store.productUuid}
                            vendor={store}
                            isWinner={store.offerId === winner.offerId}
                            isSelected={selectedSeller?.offerId === store.offerId}
                            onSelect={onSelectSeller}
                            addToCartProps={addToCartProps}
                        />
                    ))}
                </div>
            </SwipeableDrawer>
        </section>
    );
};
